import { render } from "./limpieza-habitaciones.vue?vue&type=template&id=86edd34c&scoped=true"
import script from "./limpieza-habitaciones.vue?vue&type=script&lang=js"
export * from "./limpieza-habitaciones.vue?vue&type=script&lang=js"

import "./limpieza-habitaciones.vue?vue&type=style&index=0&id=86edd34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86edd34c"]])

export default __exports__